import { HiEyeSlash } from "react-icons/hi2";

export const CloseEyeIcon = ({ width, height, color, ...props }) => (
  <HiEyeSlash
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
